import toast from "@/services/Notification";
import HTTP from "@/_helpers/http";
import { AGREEMENT__API } from "@/_helpers/urls";
import { AGREEMENT__MUTATIONS } from "../mutation-types";
import { AGREEMENT__ACTIONS } from "../action-types";

// State
const state = {
    notAcceptedAgreements: [],
    histories: [],
};

//Getters
const getters = {};

//Mutations
const mutations = {
    [AGREEMENT__MUTATIONS.NOTACCEPTEDAGREEMENTS](state, data) {
        state.notAcceptedAgreements = data?.data?.agreements;
    },
    [AGREEMENT__MUTATIONS.AGREEMENTHISTORIES](state, data) {
        state.histories = data?.data?.agreements;
    },
};

// Actions
const actions = {
    async [AGREEMENT__ACTIONS.NOTACCEPTEDAGREEMENTS]({ commit, state }) {
        try {
            const url = `${AGREEMENT__API.NOTACCEPTEDAGREEMENTS}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(AGREEMENT__MUTATIONS.NOTACCEPTEDAGREEMENTS, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [AGREEMENT__ACTIONS.AGREEMENTHISTORIES]({ commit, state }) {
        try {
            const url = `${AGREEMENT__API.AGREEMENTHISTORIES}`;
            const response = await HTTP().get(url);

            if (response.status === 200) {
                commit(AGREEMENT__MUTATIONS.AGREEMENTHISTORIES, response.data);
            }
        } catch (error) {
            console.log(error);
        }
    },
    async [AGREEMENT__ACTIONS.UPLOADAGREEMENTFILE]({ commit, dispatch }, payload) {
        try {
            console.log('payload', payload);
            const response = await HTTP().post(AGREEMENT__API.UPLOADAGREEMENTFILE, payload);
            if (response.status === 200) {
                dispatch(AGREEMENT__ACTIONS.NOTACCEPTEDAGREEMENTS);
                toast.success("Agreement uploaded successfully");
            }
        } catch (error) {
            console.error('Error uploading agreement:', error);
        }
    }
};

export default {
    namespaced: true,
    strict: process.env.NODE_ENV !== "production",
    state,
    getters,
    mutations,
    actions,
};
